import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.userAlertsSettings],
        config: {
            headerName: getLocalizedString("alertOrNoticeType"),
            field: "Tipo de Alerta o Aviso",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("name"),
            field: "Nombre",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("level"),
            field: "nivelString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("activeFemale"),
            field: "activaString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("executionMoment"),
            field: "executionMoment",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("executionTime"),
            field: "executionTime",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("alertOrNoticeText"),
            field: "Texto de la Alerta o Aviso",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("class"),
            field: "claseString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("messageBodyText"),
            field: "Texto para cuerpo del email",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("notification"),
            field: "notificacionString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("addressee"),
            field: "destString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("whatsappTemplate"),
            field: "templateString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.userAlertsSettings],
        config:
        {
            headerName: getLocalizedString("specialProcessToExecute"),
            field: "processToExecute",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.systemAlertsSettings],
        config: {
            headerName: getLocalizedString("alertOrNoticeType"),
            field: "Tipo de Alerta o Aviso",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.systemAlertsSettings],
        config:
        {
            headerName: getLocalizedString("name"),
            field: "Nombre",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.systemAlertsSettings],
        config:
        {
            headerName: getLocalizedString("level"),
            field: "nivelString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.systemAlertsSettings],
        config:
        {
            headerName: getLocalizedString("activeFemale"),
            field: "activaString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.systemAlertsSettings],
        config:
        {
            field: "Texto de la Alerta o Aviso",
            headerName: getLocalizedString("alertOrNoticeText"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.systemAlertsSettings],
        config:
        {
            headerName: getLocalizedString("class"),
            field: "claseString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.systemAlertsSettings],
        config:
        {
            field: "Texto para cuerpo del email",
            headerName: getLocalizedString("messageBodyText"),
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.systemAlertsSettings],
        config:
        {
            headerName: getLocalizedString("notification"),
            field: "notificacionString",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.systemAlertsSettings],
        config:
        {
            headerName: getLocalizedString("whatsappTemplate"),
            field: "templateString",
            filter: "agSetColumnFilter",
        }
    },
]